import { set_environment } from "@quiz-buzz/client-common/src/Config/Client_Environments"

const Env_Urls: { [index: string]: string } = {
    'https://preview.quiz-buzz.com': 'preview',
    'https://quiz-buzz.com': 'production',
}

export const determine_and_set_environment_for_web = () => {
    // Determine which environment we are in using the URL:
    const loc = window.location.protocol + "//" + window.location.hostname + (window.location.port ? `:${window.location.port}` : '')
    const env_name = Env_Urls[loc] || Env_Urls['localdev']
    if (!env_name) {
        set_environment('localdev')
    }
    else {
        set_environment(env_name)
    }
}